import { createSlice } from '@reduxjs/toolkit';
import { getBills } from './actions';
import {
  BILL_MODIFIED,
  BILL_STATUS_NOTGENERATED,
  BILL_STATUS_VALIDATION,
} from 'utils/Constants';

const initialState = {
  bills: [],
  status: 'idle',
  error: null,
};

const allBills = createSlice({
  name: 'all_Bills',
  initialState,
  reducers: {
    fetchBills: (state) => {
      state.status = 'loading';
    },
    fetchBillsSuccess: (state, action) => {
      state.status = 'succeeded';
      state.bills = action.payload;
    },
    fetchBillsFailure: (state, action) => {
      state.status = 'failed';
      state.error = action.payload;
    },

    handleSorting: (state, { payload }) => {
      if (payload !== undefined) {
        let array = [...state.bills];
        if (payload.sortField) {
          const sorted = [...array].sort((a, b) => {
            if (a[payload.sortField] === null) return 1;
            if (b[payload.sortField] === null) return -1;
            let aValue = a[payload.sortField];
            let bValue = b[payload.sortField];
            if (aValue === BILL_MODIFIED) aValue = BILL_STATUS_VALIDATION;
            if (bValue === BILL_MODIFIED) bValue = BILL_STATUS_VALIDATION;
            return (
              aValue.toString().localeCompare(bValue.toString(), 'en', {
                numeric: true,
              }) * (payload.sortOrder === 'asc' ? 1 : -1)
            );
          });
          state.bills = [...sorted];
        }
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getBills.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(getBills.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.bills = action.payload;
      })
      .addCase(getBills.rejected, (state, action) => {
         state.status = 'failed';
         state.error = action.payload;
      });
  },
});

export default allBills.reducer;
export const { handleSorting } = allBills.actions;
export const AllBillsSelector = (state) => state.allBills;
